<template>
    <b-form-group
        :state="state"
        :invalid-feedback="$t('form.validations.required')"
    >
        <template slot="label">
            <span class="label"> {{ $t('nBox.calibrationType') }} </span>
        </template>
        <b-button-group size="sm">
            <b-button
                :key="item.value"
                v-for="item in options"
                :variant="getVariant(item.value)"
                @click="$emit('update:value', item.value)"
            >
                {{ item.text }}
            </b-button>
        </b-button-group>
    </b-form-group>
</template>
<script>
import i18n from '@/i18n'
export default {
    props: {
        value: {
            type: String,
            default: null,
        },
        state: {
            type: Boolean,
            default: null,
        },
    },
    methods: {
        getVariant(value) {
            if (this.state === false) {
                return 'outline-danger'
            }

            if (this.value == value) {
                return 'primary'
            }

            return 'outline-secondary'
        },
    },
    computed: {
        options() {
            return [
                { text: i18n.t('nBox.score'), value: 'score' },
                { text: i18n.t('nBox.quadrant'), value: 'quadrant' },
            ]
        },
    },
}
</script>
<style lang="scss" scoped>
::v-deep .btn-outline-secondary:hover {
    background-color: #f0f3f5 !important;
}

::v-deep .btn {
    min-width: 70px;
}
</style>
